import WorldABI from "contracts/out/IWorld.sol/IWorld.abi.json";
import worlds from "contracts/worlds.json";
import { chain } from "./chain";

const address = worlds[chain.id]?.address;
if (!address) {
  throw new Error("No address found for chain id " + chain.id);
}

export const contract = { abi: WorldABI, address, chain } as const;
